import { useMemo, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { PageHero, useQuery, Empty, Rating, SortBar } from '../../shared/components/Common';
import { SmartImg } from '../../shared/components/Layout';
import Icon from '../../shared/components/Icons';
import { formatPrice } from '../../shared/data/common';
import { activities, categories } from './data';

export default function SightseeingList() {
  const q = useQuery();
  const { search } = useLocation();
  const [cat, setCat] = useState(q.category || 'All');
  const [sort, setSort] = useState('popular');

  const list = useMemo(() => {
    let r = activities.filter((s) => (!q.city || s.city === q.city) && (cat === 'All' || s.category === cat));
    if (sort === 'popular') r = [...r].sort((a, b) => b.reviews - a.reviews);
    if (sort === 'rating') r = [...r].sort((a, b) => b.rating - a.rating);
    if (sort === 'low') r = [...r].sort((a, b) => a.price - b.price);
    return r;
  }, [q.city, cat, sort]);

  return (
    <>
      <PageHero tab="sightseeing" title={q.city ? `Things to do in ${q.city}` : 'Tours & attractions'}
        subtitle="Skip-the-line tickets, guided tours and unforgettable experiences" query={q} />
      <div className="container">
        <div className="theme-chips">
          {categories.map((c) => (
            <button key={c} className={`chip lg ${cat === c ? 'active' : ''}`} onClick={() => setCat(c)}>{c}</button>
          ))}
        </div>
        <SortBar count={list.length} label="experiences" sort={sort} setSort={setSort} options={[['popular', 'Popular'], ['rating', 'Top rated'], ['low', 'Price ↑']]} />
        {!list.length && <Empty text="No experiences found for this city yet." />}
        <div className="card-grid">
          {list.map((s) => (
            <Link key={s.id} to={`/sightseeing/${s.id}${search}`} className="card hover">
              <div className="card-img">
                <SmartImg src={s.image} alt={s.title} />
                <span className="badge badge-sky">{s.category}</span>
              </div>
              <div className="card-body">
                <span className="muted small"><Icon name="pin" size={12} /> {s.city} · <Icon name="clock" size={12} /> {s.duration}</span>
                <h3>{s.title}</h3>
                <Rating value={s.rating} reviews={s.reviews} />
                <span className="text-primary small"><Icon name="check" size={12} /> Free cancellation · Instant confirmation</span>
                <div className="price-row">
                  <div><span className="muted small">from </span><b className="price">{formatPrice(s.price)}</b><span className="muted small"> /adult</span></div>
                  <span className="btn btn-primary btn-sm">View</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </>
  );
}
